__webpack_require__.p = "//static.hsappstatic.net/forecasting-ui/static-1.40784/";